import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { baseURL } from './backend_url';
import axios from 'axios';
import './ActiveLocations.css';
import Swal from 'sweetalert2';

function ActiveLocations() {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [locationAll, setLocationAll] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [allLocationData, setAllLocationData] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [access, setAccess] = useState("Edit");

  // useEffect(() => {
  //   axios.get(baseURL + "/get_company_details_for_users")
  //     .then((res) => {
  //       setCompanyDetail(res.data);
  //     });
  // }, []);

  useEffect(() => {
    if (companyName) {
      const loggedInUser = sessionStorage.getItem("user_token");
      const foundUser = JSON.parse(loggedInUser);
 
      if('Users' === foundUser.role){
      setAccess(foundUser.access['ActiveLocations_Access Specifier']);
      }
      const companyIdTemp = '690337'
      setCompanyId(companyIdTemp);

      axios.get(baseURL + "/get_company_location/" + companyIdTemp)
        .then((res) => {
          axios.get(baseURL + "/srt_get_active_location/" + companyIdTemp.toString())
            .then((res1) => {
              let allTemp = res.data.res;
              let hashLocationNameId = {};
              allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
              setHashLocationNameVsID(hashLocationNameId);
              if (allTemp.length > 0) {
                let tempArr = [];
                let tempObj = {};
                for (let i = 0; i < allTemp.length; i += 4) {
                  let tempArr2 = [];
                  for (let j = i; j < i + 4; j++) {
                    if (allTemp[j]) {
                      tempArr2.push(allTemp[j].location_id);

                      if (res1.data[allTemp[j].location_id] == true) {
                        tempObj[allTemp[j].location_id] = true;
                      }
                      else {
                        tempObj[allTemp[j].location_id] = false;
                      }
                    }
                  }
                  tempArr.push(tempArr2);
                }
                setAllLocationData(tempArr);
                setSelectedLocation(tempObj);

              }
            })
        });
      // }
    }
  }, []);

  const companyNameOptions = companyDetail.map((value) => ({
    value: value.company_name, label: value.company_name
  }));

  const handleInputChangeCompanyName = (selectedOption) => {
    setCompanyName(selectedOption.value);
  };

  const handleLocationAll = (checked) => {
    setLocationAll(checked);
    const updatedSelectedLocations = { ...selectedLocation };
    Object.keys(updatedSelectedLocations).forEach(key => {
      updatedSelectedLocations[key] = checked;
    });
    setSelectedLocation(updatedSelectedLocations);
  };

  const handleLocation = (locationId) => {
    setSelectedLocation(prevState => {
      const updatedState = {
        ...prevState,
        [locationId]: !prevState[locationId]
      };
      const allSelected = Object.values(updatedState).every(val => val === true);
      setLocationAll(allSelected);
      return updatedState;
    });
  };

  const handleSubmit = () => {
    const selectedLocations = Object.keys(selectedLocation).filter(key => selectedLocation[key]);
    console.log('Selected Locations:', selectedLocations);
    // further actions here
    if (companyName === "") {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please select Account Name to proceed ahead',
      })
      return;
    }
    const obj = {
      'account_id': companyId.toString(),
      selectedLocation: selectedLocation,
      updated_by: 'demo@routes.ca'
    }
    axios.post(baseURL + "/srt_save_active_locations", obj)
      .then((res) => {
        Swal.fire({
          position: 'middle',
          icon: 'success',
          title: 'Saved Successfully!',
          showConfirmButton: false,
          timer: 3000
        })
      })
  };

  return (
    <div className="container mt-5">
      <div className="p-5 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">Active Locations</h4>
        {/* <div className="mb-4">
          <label htmlFor="company_name" className="form-label">
            Select Account
          </label>
          <Select
            value={{ value: companyName, label: companyName || "Select Account Name" }}
            inputId="company_name"
            name="company_name"
            options={companyNameOptions}
            onChange={handleInputChangeCompanyName}
          />
        </div> */}
        {companyName && (
          <div className="mb-4">
            {/* <label htmlFor="location_picker" className="form-label"> */}
            {/* <strong>Location</strong> */}
            {/* </label> */}
            {/* <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                checked={locationAll}
                onChange={() => handleLocationAll(!locationAll)}
              />
              <label className="form-check-label ms-2">Select All</label>
            </div> */}
            <table className="table table-borderless mt-3">
              <tbody>
                {allLocationData.map((val, i) => (
                  <tr key={i}>
                    {val.map((val2, j) => (
                      <React.Fragment key={j}>
                        <td width='1px'>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedLocation[val2]}
                            onChange={() => handleLocation(val2)}
                          />
                        </td>
                        <td>{`${hashLocationNameVsID[val2]} - ${val2.split('-')[1]}`}</td>
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {companyName && access === 'Edit' && (
          <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
        )}
      </div>
    </div>
  );
}

export default ActiveLocations;
